$ = require 'jquery'
Browser = require '@trello/browser'
PopUpWindow = require 'views/lib/pop-up-window'
Util = require 'lib/util'
View = require 'view'
template = require 'views/templates/error'

module.exports = class ErrorView extends View

  events:
    'click .js-login': 'login'

  login: (e) ->
    Util.stop(e)

    returnUrl = if Browser.isEmbeddedDocument() then '/embed/login' else @model.url
    loginUrl = "/login?" + $.param
      returnUrl: returnUrl

    if Browser.isEmbeddedDocument()
      new PopUpWindow(loginUrl).open()
    else
      window.location = loginUrl

  render: ->
    @$el.html template(@model)
    @



// WEBPACK FOOTER //
// ./app/scripts/views/error/error-view.coffee